import { Injectable } from '@angular/core';
import { assert } from '@sama/js-core';
import { UrlRequestService } from '../misc-services/resources/url-request.service';

@Injectable({ providedIn: 'root' })
export class BlobService {
  constructor(private urlRequestService: UrlRequestService) {}

  async canvasToBlob(canvas: HTMLCanvasElement) {
    return new Promise<Blob>((resolve) => {
      canvas.toBlob((blob) => {
        assert(blob, "We can't find any docs saying when this could be null..");
        resolve(blob);
      });
    });
  }

  // assetId is only used in tests for memory concerns, unused in production
  saveToBlobStore(asset: ArrayBuffer, _assetId: string) {
    return URL.createObjectURL(new Blob([asset]));
  }

  getFromBlobStore(blobUrl: string) {
    return this.urlRequestService.request<ArrayBuffer>('GET', blobUrl, {
      responseType: 'arraybuffer',
    });
  }

  releaseBlobUrl(blobUrl: string) {
    URL.revokeObjectURL(blobUrl);
  }
}
